import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Layout from "@/components/Layout";
import api from "@/lib/api";
import { getLang, t } from "@/lib/i18n";
import * as Icons from "lucide-react";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";

export default function Categories() {
  const [cats, setCats] = useState([]);
  const [lang, setLang] = useState(getLang());
  const nav = useNavigate();

  useEffect(() => {
    const h = () => setLang(getLang());
    window.addEventListener("lang-change", h);
    return () => window.removeEventListener("lang-change", h);
  }, []);

  useEffect(() => {
    api.get("/categories").then((r) => setCats(r.data));
  }, []);

  const nameFor = (c) => c[`name_${lang}`] || c.name_pt;

  return (
    <Layout>
      <div className="max-w-6xl mx-auto px-6 py-16 fade-in">
        <div className="mb-12 flex flex-col sm:flex-row sm:items-end justify-between gap-4">
          <div>
            <div className="font-mono text-xs uppercase tracking-widest text-muted-foreground mb-3">// {cats.length} {t(lang, "categories").toLowerCase()}</div>
            <h1 className="font-serif text-4xl sm:text-5xl font-medium tracking-tight">{t(lang, "categories")}</h1>
            <p className="text-muted-foreground mt-2 max-w-xl">Escolhe uma categoria para estudar as perguntas ou iniciar um simulado aleatório de 30 perguntas.</p>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4 stagger" data-testid="categories-grid">
          {cats.map((c) => {
            const Icon = Icons[c.icon] || Icons.BookOpen;
            return (
              <div key={c.code} data-testid={`category-card-${c.code}`}
                className="group border border-border bg-card rounded-lg p-6 hover:border-[hsl(var(--accent))] transition-colors cursor-pointer relative overflow-hidden"
                onClick={() => nav(`/categories/${c.code}`)}
              >
                <div className="flex items-start justify-between mb-8">
                  <div className="w-11 h-11 rounded-md bg-[hsl(var(--accent))]/10 text-[hsl(var(--accent))] flex items-center justify-center group-hover:bg-[hsl(var(--accent))] group-hover:text-[hsl(var(--accent-foreground))] transition-colors">
                    <Icon className="w-5 h-5" />
                  </div>
                  <div className="font-mono text-xs text-muted-foreground">{c.code}</div>
                </div>
                <h3 className="font-serif text-xl font-medium leading-tight mb-1">{nameFor(c)}</h3>
                <div className="text-sm text-muted-foreground mt-3 flex items-center justify-between">
                  <span>{c.question_count} {t(lang, "questions")}</span>
                  <ArrowRight className="w-4 h-4 opacity-40 group-hover:opacity-100 group-hover:translate-x-1 transition-all" />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </Layout>
  );
}
